import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/Text';
import { PressableNeolexon } from '@/components/PressableNeolexon';

import { styles } from './styles';

export const COLOR_MAP = {
  '#BDDCFF': '#3B82C4',
  '#CFEDE0': '#359370',
  '#FFBDBD': '#CE4B4B',
  '#BDF0FF': '#2C8CAB',
  '#FFE0BD': '#C77F2E',
  '#F4C9DD': '#BC5185',
} as const;

export type ColorOption = keyof typeof COLOR_MAP;
export type ColorAccent = (typeof COLOR_MAP)[ColorOption];

const COLOR_OPTIONS = Object.keys(COLOR_MAP) as ColorOption[];

export const DEFAULT_PROFILE_COLOR = COLOR_OPTIONS[0];

export const ColorPicker = ({
  onColorPress,
  profileColor,
  patientInitials = '',
}: {
  onColorPress: (color: ColorOption) => void;
  profileColor: ColorOption | '';
  patientInitials?: string;
}) => {
  const [selectedProfileColor, setSelectedProfileColor] = useState<ColorOption>(
    profileColor || COLOR_OPTIONS[0],
  );

  useEffect(() => {
    setSelectedProfileColor(profileColor || DEFAULT_PROFILE_COLOR);
  }, [profileColor]);

  return (
    <>
      <View>
        <Text style={styles.heading}>Profil anpassen</Text>
        <Text style={styles.description}>
          Zur besseren Unterscheidung Ihrer Patient:innen haben Sie die
          Möglichkeit, eine Farbe als Profilbild festzulegen.
        </Text>
      </View>

      <View style={styles.content}>
        <View
          style={[
            styles.selectedColorWrapper,
            {
              backgroundColor: selectedProfileColor,
              borderColor: COLOR_MAP[selectedProfileColor],
            },
          ]}
        >
          <Text style={styles.profileInitials} androidTrailingSpace={false}>
            {patientInitials.toUpperCase()}
          </Text>
        </View>

        <View style={styles.picker}>
          {COLOR_OPTIONS.map((color, index) => (
            <PressableNeolexon
              key={index}
              testID={`patient-color-option-${color}`}
              onPress={() => {
                setSelectedProfileColor(color);
                onColorPress(color);
              }}
            >
              <View
                style={[
                  styles.color,
                  { backgroundColor: color },
                  selectedProfileColor === color
                    ? { borderColor: COLOR_MAP[color], borderWidth: 2 }
                    : {},
                ]}
              >
                {selectedProfileColor === color ? (
                  <Icon
                    name="check"
                    size={36}
                    style={{ color: COLOR_MAP[color] }}
                  />
                ) : null}
              </View>
            </PressableNeolexon>
          ))}
        </View>
      </View>
    </>
  );
};
